




































































































































import Vue from 'vue'
import { ofices } from '../example-data'

const sandboxTemplateHTML =
`<v-cascader
    :autocomplete="autocomplete"
    :chips="chips"
    :dense="dense"
    :itemText="name"
    :multiple="multiple"
    :items="items"
    :clearable="clearable"
    :dark="dark"
    :showFullPath = "showFullPath"
    :delimeter = "delimeter"
    item-key ="name"
    v-model = "selectedItems"
    >
'</v-cascader>`

const sandboxCode =
`export default ({
  data: () => ({
    items: ofices, // see data source
    chips: false,
    multiple: false,
    dense: false,
    clearable: false,
    dark: false,
    autocomplete: false,
    selectedItems: []
  })
})`

export default Vue.extend({
  data: () => ({
    items: ofices,
    name: 'name',
    chips: false,
    smallChips: false,
    deletableChips: false,
    multiple: false,
    dense: false,
    clearable: false,
    dark: false,
    autocomplete: false,
    showFullPath: false,
    delimeter: '/',

    selectedItems: [],
    //
    codeSandbox: false,
    sandboxTemplate: sandboxTemplateHTML,
    sandboxCode: sandboxCode,
    dataSource: ofices
  })
})
